import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import LoginPage from './pages/LoginPage';
import AccountPage from './pages/AccountPage';
import HomePage from './pages/HomePage';
import AdminPage from './pages/AdminPage';
import UnauthorizedPage from './pages/UnauthorizedPage';
import ComingSoonPage from './pages/ComingSoonPage';
import ProtectedRoute from './routes/ProtectedRoute';
import { CustomThemeProvider } from './styles/CustomThemeProvider';

// When REACT_APP_LAUNCH_MODE=coming_soon (set on prod builds only via
// deploy.yml's deploy-prod env block), the public marketing surfaces
// (/ and /home) render a holding page. Auth routes are left untouched.
const launchHidden = process.env.REACT_APP_LAUNCH_MODE === 'coming_soon';

const App = () => {
  return (
    // <ThemeProvider theme={themeBase}>
    <CustomThemeProvider>
      <AuthProvider>
        {/* <Router> */}
        <Routes>
          <Route path='/' element={launchHidden ? <ComingSoonPage /> : <RootRedirect />} />
          <Route path="/home" element={launchHidden ? <ComingSoonPage /> : <HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/unauthorized" element={<UnauthorizedPage />} />
          <Route element={<ProtectedRoute roles={['admin']} />}>
            <Route path="/admin" element={<AdminPage />} />
          </Route>
          <Route element={<ProtectedRoute roles={['admin', 'advisor', 'student', 'user']} />}>
            <Route path="/account" element={<AccountPage />} />
          </Route>
        </Routes>
        {/* </Router> */}
      </AuthProvider>
    </CustomThemeProvider>
    // </ThemeProvider>
  );
};

// adding comment to force update
const RootRedirect = () => {
  //const { token } = useAuth();
  const token = true;
  return token ? <Navigate replace to='/home' /> : <Navigate replace to='/login' />;
};

export default App;
